<script lang="ts" setup>
const props = defineProps({
  name: {
    type: String,
    required: true
  }
});

const icon = ref<string | Record<string, any>>('');
let hasStroke = ref(false);

async function getIcon() {
  try {
    const iconsImport = import.meta.glob('@/assets/icons/**/**.svg', {
      query: '?raw',
      eager: false,
      import: 'default'
    });
    const rawIcon = await iconsImport[`/src/assets/icons/${props.name}.svg`]() as string;

    if (rawIcon.includes('stroke')) {
      hasStroke.value = true;
    }
    icon.value = rawIcon;
  } catch {
    console.error(
      `[icon] Icon '${props.name}' doesn't exist in 'assets/icons'`
    );
  }
}

watchEffect(getIcon);
</script>

<template>
  <span
    class="base-icon"
    :class="{ 'is-fill': !hasStroke, 'is-stroke': hasStroke }"
    v-html="icon"
  />
</template>

<style lang="scss" scoped>
.base-icon {
  display: grid;
  place-content: center;

  :deep(svg) {
    width: 1em;
    height: 1em;
  }

  &.is-fill {
    :deep(svg) {
      &,
      * {
        fill: currentColor !important;
      }
    }
  }

  &.is-stroke {
    :deep(svg) {
      &,
      * {
        stroke: currentColor !important;
      }
    }
  }
}
</style>
